module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/coffee-kitchen-small-9cde6d58b79bd79b4411fbbdb35a83d7.svg";